import types from './action-types';

const moduleName = 'gis-map';
const service = abp.services.api.gisMapDataService;

export const filterData = (visible, projectId, axisId, chapterId, profileId) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.FILTER_CHANGED,
            data: { visible, projectId, axisId, chapterId, profileId }
        });
    }
};

export const filterAuxDrawings = (visible, projectId, drawingId) => {
  return (dispatch, getState) => {
      dispatch({
          type: types.AUXDRAWINGS_CHANGED,
          data: { visible, projectId, drawingId }
      });
  }
};

export const filterDataByDates = (dateFrom, dateTo) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.DATE_FILTER_CHANGED,
            data: { dateFrom, dateTo }
        });
    }
};

export const displayModeChanged = (selectedDisplayMode) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.DISPLAY_MODE_CHANGED,
            data: { selectedDisplayMode }
        });
    }
};

export const toggleFilter = (visible) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.TOGGLE_FILTER,
            data: { visible }
        });
    }
};

export const zoomChanged = (zoom) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.ZOOM_CHANGED,
            data: { zoom }
        });
    }
};

export const loadData = (projectId) => {
    return (dispatch) => {
        loadDataInternal(projectId, dispatch);
    }
};

export const loadLinkedData = (projectId) => {
    return (dispatch) => {
        loadLinkedDataInternal(projectId, dispatch);
    }
}

const loadDataInternal = (projectId, dispatch) => {
    dispatch({ type: types.LOADING, projectId });
    service.getData(projectId)
        .done(result => {
            dispatch({
                type: types.DATA_LOADED,
                data: result
            });
        });
};

const loadLinkedDataInternal = (projectId, dispatch) => {
    service.getLinkedData(projectId)
        .done(result => {
            dispatch({
                type: types.LINKEDDATA_LOADED,
                data: result
            });
        })
}



// WEBPACK FOOTER //
// ./App/components/modules/gis-map/actions.js